import { http } from "../config.api.js"
// 项目相关
export const listProjectsForPM = (pageInfo, params) => { return http.get("/tproject/projectsForPM/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listItem = (pageInfo, params) => { return http.get("/item/findHyItemsByProId/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listProjectExtend = (pageInfo, params) => { return http.get("/tproject/projectExtend/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listProjectUpdate = (pageInfo, params) => { return http.get("/tproject/projectUpdate/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listPersonChangeHistory = (params) => { return http.get("/tproject/getPersonChangeHistory/", { urlParams: params }).then(res => res.data); };

export const listProConstrs = (pageInfo, params) => { return http.get("/tproject/getProConstrs/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listSBItem = (params) => { return http.get("/tproject/findHyItemListForSB/", { urlParams: params }).then(res => res.data); };

export const viewItemForSB = (params) => { return http.get("/tproject/viewItemForSB/", { urlParams: params }).then(res => res.data) };

export const getProItemDetail = (params) => { return http.get("/tproject/getProItemDetail/", { urlParams: params }).then(res => res.data) };

export const getProUint = (params) => { return http.get("/tproject/getProUnitPersonInfo/", { urlParams: params }).then(res => res.data) };

export const getPersonInfo = (params) => { return http.get("/unitPerson/getPersonInfo/", { urlParams: params }).then(res => res.data) };

export const getProServeRecord = (params) => { return http.get("/tproject/getProServeRecord/", { urlParams: params }).then(res => res.data) };

export const getServeDetailForSG = (params) => { return http.get("/tproject/getServeDetailForSG/", { urlParams: params }).then(res => res.data) };

export const bgNumView = (params) => { return http.get("/tproject/bgNumView", { urlParams: params }).then(res => res.data) };

export const pmErpChange = (params) => { return http.get("/tproject/pmErpChange", { urlParams: params }).then(res => res.data) };

export const jlPersonMessageView = (params) => { return http.get("/tproject/jlPersonMessageView", { urlParams: params }).then(res => res.data) };

export const sgPersonMessageView = (params) => { return http.get("/tproject/sgPersonMessageView", { urlParams: params }).then(res => res.data) };

export const inDeNumView = (params) => { return http.get("/tproject/inDeNumView", { urlParams: params }).then(res => res.data) };

export const personMessageViewForHxAndXz = (params) => { return http.get("/tproject/personMessageViewForHxAndXz", { urlParams: params }).then(res => res.data) };

export const unitChangeShow = (params) => { return http.get("/tproject/unitChangeShow", { urlParams: params }).then(res => res.data) };

export const unitUnions = (params) => { return http.get("/tproject/queryUnitUnionsByPid", { urlParams: params }).then(res => res.data) };
export const superBindPro = (params) => { return http.get("/tproject/querySuperBindProByProId", { urlParams: params }).then(res => res.data) };
export const subUnitPerson = (params) => { return http.get("/tproject/querySubUnitPersonByPid", { urlParams: params }).then(res => res.data) };
export const getConstrId = (params) => { return http.get("/tproject/getConstrId", { urlParams: params }).then(res => res.data) };
export const queryPersonEquips = (params) => { return http.get("/tproject/queryPersonEquips", { urlParams: params }).then(res => res.data) };
export const delareItemQuery = (pageInfo, params) => { return http.get("/tproject/delareItemQuery/" + pageInfo, { urlParams: params }).then(res => res.data); };



// WEBPACK FOOTER //
// ./src/api/project/api_project.js